import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Tag } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Discount } from '@grandvisionhq/fun-products';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import ProductReimbursableLogo from '../../ProductReimbursableLogo/ProductReimbursableLogo.js';
import { isContactLenses } from '../types.js';
import Details from './Details/Details.js';
import Images from './Images/Images.js';
import Prices from './Prices/Prices.js';
import PromotionLabel from './PromotionLabel/PromotionLabel.js';
import VariantSwitcher from './VariantSwitcher/VariantSwitcher.js';

const ProductBlock = /*#__PURE__*/ React.forwardRef(({ brand , discounted , name , url , productType , activeSku , images , price , discountedPrice , variants , offering , promotionLabel , className , onVariantChange , onClick , isInsuranceReimbursable , reimbursableLogos , isReimbursableFiltered , tag ,  }, ref)=>{
    const { getFormattedLabel  } = useIntl();
    const isLargeScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    if (!activeSku || !isDefined(price) || !url) {
        console.warn(`Cannot render ProductBlock component without a valid price: ${price} and url: ${url} and active sku: ${activeSku}.`);
        return null;
    }
    const { isProductLabelEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement("a", {
        ref: ref,
        href: url,
        onClick: onClick,
        "aria-label": `${brand} ${name}`,
        "data-t": "product-block",
        className: classnames('product-block', {
            'product-block--contact-lenses': isContactLenses(productType)
        }, className)
    }, /*#__PURE__*/ React.createElement("aside", {
        className: "product-block__header"
    }, isProductLabelEnabled && promotionLabel && /*#__PURE__*/ React.createElement(PromotionLabel, null, promotionLabel), !isProductLabelEnabled && tag && /*#__PURE__*/ React.createElement(Tag, {
        className: "product-block__header-tag",
        iconKey: tag.key,
        label: tag.value
    }), isLargeScreen && isInsuranceReimbursable && /*#__PURE__*/ React.createElement(ProductReimbursableLogo, {
        logos: reimbursableLogos,
        variant: isReimbursableFiltered ? 'alternative' : 'default'
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-block__main"
    }, /*#__PURE__*/ React.createElement(Images, {
        front: images.front,
        angle: images.angle
    }), /*#__PURE__*/ React.createElement(Details, {
        brand: brand,
        name: name
    }), /*#__PURE__*/ React.createElement(Prices, {
        price: price,
        discountedPrice: discountedPrice
    }), !isProductLabelEnabled && discounted && /*#__PURE__*/ React.createElement(Discount, {
        className: "product-block__discount",
        label: promotionLabel,
        discount: discounted
    })), /*#__PURE__*/ React.createElement("footer", {
        className: "product-block__footer"
    }, !!(variants === null || variants === void 0 ? void 0 : variants.length) && /*#__PURE__*/ React.createElement(VariantSwitcher, {
        variants: variants,
        activeSku: activeSku,
        onVariantChange: onVariantChange,
        className: "product-block__variant-switcher"
    }), (offering === null || offering === void 0 ? void 0 : offering.includesLenses) && /*#__PURE__*/ React.createElement(Text, {
        className: "product-block__bottom-link"
    }, getFormattedLabel('products.glasses.offering.includesLenses', {
        parseLink: true,
        hideLabelKey: true
    }))));
});
var ProductBlock$1 = ProductBlock;

export { ProductBlock, ProductBlock$1 as default };
//# sourceMappingURL=ProductBlock.js.map
